module.exports = __webpack_public_path__ + "img/thumb_17.38a6e84a.jpg";